import http from "@/http-common.js";

class CompaniesYandexrentService {

  basePathApiService = "/super/companies";
 
  getAll(params) {
    return http.get(this.basePathApiService, params);
  } 

}
export default new CompaniesYandexrentService();
